import { encodeQS } from "../../../lib/utils/QueryStringUtils.js";

type SupportedMethod = "GET" | "POST" | "PUT"




/**
 * Abstract base class for collecting statistics via HTTP requests.
 * 
 * This class provides a generic mechanism to send statistics data to a specified endpoint
 * using either POST/PUT (with JSON body) or GET (with query string, via image beacon).
 * 
 * @remarks
 * - For POST and PUT methods, data is sent as a JSON payload.
 * - For other methods (typically GET), data is encoded as a query string and sent using an image beacon.
 * - Handles asynchronous collection and error reporting.
 * 
 * @example
 * ```typescript
 * class MyStatsCollector extends GenericQSStatsCollector {
 *   // Implement specific logic if needed
 * }
 * ```
 * 
 * @param name - The name of the collector.
 * @param baseUrl - The base URL to which statistics are sent.
 */
export abstract class GenericQSStatsCollector {



    constructor(public readonly name: string, 
                public readonly baseUrl: string) {

    }


    public collect(method: SupportedMethod, data?: {[k:string]: any}): Promise<void> {

        if(method == "POST" || method == "PUT") {
            const body = JSON.stringify(data);
            return fetch(this.baseUrl,{
                method: method,
                headers: {
                    "Content-Type": "application/json"
                },
                body: body
            }).then();
        }
        else {
            const qs = encodeQS(data,true);
            const url = this.baseUrl + "?" + qs;
            try {
                return new Promise((resolve,reject) => {
                    const img = new Image();
                    img.onload = () => resolve();
                    img.onerror = () => reject("error on stats marking")
                    img.src = url;
                })
                
            }
            catch(e) {
                return Promise.reject("error on stat marking " + e);
            }
        }
    }
}